import React from 'react';

import {
  useInterestsState,
  useInterestsActions,
} from './InterestsContext';

import { getInterests } from './restApi';

import PageController from '../../Shared/UI/PageController/components/PageController';

const InterestsPageController = () => {
  const state = useInterestsState();
  const { onResponse, onError } = useInterestsActions();

  return (
    <PageController
      pageNumber={state?.pageNumber}
      numberOfPages={state?.numberOfPages}
      goToFirstPage={() => {
        getInterests({
          onResponse,
          onError,
          pageNumber: 1,
        });
      }}
      goToPreviousPage={() => {
        getInterests({
          onResponse,
          onError,
          pageNumber: (state?.pageNumber - 1),
        });
      }}
      goToNextPage={() => {
        getInterests({
          onResponse,
          onError,
          pageNumber: (state?.pageNumber + 1),
        });
      }}
      goToLastPage={() => {
        getInterests({
          onResponse,
          onError,
          pageNumber: state?.numberOfPages,
        });
      }}
    />
  );
};

export default InterestsPageController;
